Ext.define('SA.RankingExportConfig', {
    extend: 'SA.ExportConfig',

    resource: 'data/location',

    constructor({maximumChildren}) {
        this.callParent(arguments);

        this.maximumChildren = maximumChildren;
    },

    getExportWindowTitle() {
        return `Export ${this.maximumChildren !== null ? `Top ${this.maximumChildren}` : 'All'} Rows`;
    },

    async prepare() {
        var {aggregates, fields: select, filter, sort, where: locationSeries} = this.model.getExportQuery(),
            transpose = false;

        this.params = {aggregates, locationSeries, select, sort, transpose};

        if (filter) {
            this.params.filter = filter;
        }

        if (this.maximumChildren) {
            this.params.slice = [0, this.maximumChildren];
        }

        this.limitCheck = await SA.LimitCheck.getForLocations(this.params);
    }
});